import { render, staticRenderFns } from "./ItemSkeleton.vue?vue&type=template&id=469fc3be&scoped=true&"
var script = {}
import style0 from "./ItemSkeleton.vue?vue&type=style&index=0&id=469fc3be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469fc3be",
  null
  
)

export default component.exports